import { Route } from "react-router-dom";
import { pages } from "../../../utils/common";
import InstituteView from "./institute.view";
import CreateInstituteView from "./createInstitute.view";
import InstituteDetailView from "./instituteDetail.view";

const useInstituteRoutes = () => (
  <>
    <Route path={pages.institute.path} element={<InstituteView />}>
      <Route index element={<InstituteView />} />
    </Route>
    <Route
      path={`${pages.institute.path}/create`}
      element={<CreateInstituteView />}
    />
    <Route
      path={`${pages.institute.path}/:id`}
      element={<InstituteDetailView />}
    />
  </>
);

export default useInstituteRoutes;
